export default () => ({
    user: null,
    newUser: {
        name: null,
        password: null,
        password_confirmation: null,
        email: null,
        phone: null
    },
    company: null,
    token: null,
    isConnected: false,
    weakConnection: false,
    isPushNotifActived: false
})
